export default "__VITE_ASSET__e4fccc36__"